// src/context/SearchContext.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { API } from "../lib/axios";

const SearchContext = createContext(null);

export const SearchProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // debounced API call
  const term = useMemo(() => {
    return query.trim().replace(/\s+/g, " ");
  }, [query]);
  
  useEffect(() => {
    if (!open) return;
    if (!term) { 
      setResults([]); 
      return; 
    }
  
    const t = setTimeout(async () => {
      try {
        setLoading(true);
        const res = await API.get("/products/search", { params: { q: term } });
        // Handle new pagination response format
        const data = res.data?.data || res.data || [];
        setResults(data);
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 300);
  
    return () => clearTimeout(t);
  }, [term, open]);  // ✅ depend on term not raw query

  const value = useMemo(() => ({
    open, setOpen, query, setQuery, results, loading
  }), [open, query, results, loading]);

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
};

export const useSearch = () => useContext(SearchContext);
